import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="none" fillRule="evenodd"><path d="M8 16.5H2.5a1 1 0 01-1-1v-11a1 1 0 011-1h19a1 1 0 011 1V10h0" stroke="#000" strokeLinejoin="round" /><rect stroke="#020202" x="12.5" y="7.5" width="6" height="6" rx="2" /><path d="M11.5 15.5h8a2 2 0 012 2v4h0-12v-4a2 2 0 012-2z" stroke="#000" strokeLinejoin="round" /></g></svg>;